import React from 'react';
import { Icon, Text } from '../../Atoms';
import { green, red } from '../../Config/Config';
import ContractIcon from '../../assets/icons/Contract.svg';

const ContractList = ({ contracts, onSelectContract, user }) => {
  return (
    <>
      {contracts?.map((contract) => (
        <ContractItem
          key={contract.contractNumber}
          contract={contract}
          onSelect={onSelectContract}
          user={user}
        />
      ))}
    </>
  );
};

export default ContractList;

const ContractItem = ({ contract, onSelect, user }) => {
  return (
    <div
      key={contract.contractNumber} // Added a unique key
      className="contract-item-container"
      onClick={() => onSelect(contract)}
    >
      <div className="contract-item-content">
        <div>
          <img src={ContractIcon} alt="Contract Icon" />
        </div>
        <div>
          <Text
            className="contract-title"
            text={`Assurance ${contract?.productFamily}`}
          />
          <Text
            className="remboursement-desktop-text"
            text={`N°${contract?.contractNumber}`}
          />
          <div className="beneficiary-info">
            <Text
              className="contract-benef-title"
              text={`Bénéficiaire${contract.beneficiaries?.length ? 's' : ''}`}
            />
            <Text
              className="contract-benef-name"
              text={`${user?.lastName} ${user?.firstName}`}
            />
            {contract.beneficiaries?.map((benef) => (
              <Text
                key={benef.fullName}
                className="contract-benef-name"
                text={`${benef?.fullName}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="contract-amount-container">
        <div>
          <Text
            className="contract-benef-title"
            text={`${contract.monthPrice} € /mois`}
          />
          <Text
            className="contract-benef-name"
            text={`a démarré le ${new Date(
              contract.effectDate
            ).toLocaleDateString('fr-FR')}`}
          />
          <div className="status-info">
            <Text className="contract-benef-title" text={`Statut :`} />
            <Text
              className="contract-benef-title"
              text={` ${contract?.status}`}
              style={{
                color: contract?.status === 'EN COURS' ? green : red
              }}
            />
          </div>
        </div>

        <div className="remboursement-desktop-organism-sort-icon-container">
          <Icon icon={'SortTop'} size="20px" className="icon-next-step" />
        </div>
      </div>
    </div>
  );
};
